import { render } from "./notification.vue?vue&type=template&id=31f01edb&scoped=true"
import script from "./notification.vue?vue&type=script&lang=js"
export * from "./notification.vue?vue&type=script&lang=js"

import "./notification.vue?vue&type=style&index=0&id=31f01edb&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f01edb"]])

export default __exports__